<template>
  <view class="worry-free-cancellation-bar">
    <view class="title-info" bindtap="openServiceDesc">
      <view class="title">退改无忧</view>
      <Icon
        wx:if="{{!timing}}"
        class="circle-question-mark"
        size="20"
        color="#999"
        name="circle-question-mark"
      />
      <view wx:else class="detail">
        详情<Icon class="right-thin-arrow" size="16" color="#999" name="right-thin-arrow" />
      </view>
    </view>
    <view class="service-status" wx:class="{{{order: timing}}}">
      <Icon
        wx:if="{{timing}}"
        class="checkmark-circle"
        size="24"
        color="#00A442"
        name="checkmark-circle"
      />
      <view class="status-text">{{ statusText }}</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'

  createComponent({
    props: {
      // 时机 0为填单页成单前 1为订单页成单后
      timing: {
        type: Number,
        value: 0
      }
    },
    data() {
      return {}
    },
    computed: {
      ...store.mapState({
        totalDiscountHandFee: 'order.base_info.totalDiscountHandFee'
      }),
      statusText() {
        return this.timing
          ? this.totalDiscountHandFee
            ? `服务已生效，共节省${getFinalPrice(this.totalDiscountHandFee)}元`
            : '服务保障中'
          : '已开启'
      }
    },
    methods: {
      openServiceDesc() {
        this.triggerEvent('openServiceDesc')
      }
    }
  })
</script>

<style scoped lang="stylus">
  .worry-free-cancellation-bar
    display flex
    justify-content space-between
    align-items center
    box-sizing border-box
    padding 16px 14px
    background #fff
    margin-bottom 9.5px
    border-radius 8px
    .title-info
      display flex
      align-items center
      .title
        font-size 16px
        color #333
        font-family PingFangSC-Semibold
        font-weight 600
      .circle-question-mark
        margin-left 4px
      .detail
        display flex
        align-items center
        color #999
        font-size 14px
        margin-left 6px
        .right-thin-arrow
          margin-left 4.5px
    .service-status
      display flex
      align-items center
      font-size 14px
      color #999
      font-family PingFangSC-Medium
      font-weight 500
      .checkmark-circle
        margin-right 2px
      &.order
        color #00A442
        font-size 12px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      Icon: '@didi/spring-icon'
    }
  }
</script>